import React ,  {useEffect, useState}from 'react'
import { Button, Form ,TextArea, Image, Divider, Icon} from 'semantic-ui-react';
import { Field, useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { PUBLIC_COMPLET } from '../../../../gql/publication';
import captura from "../../../../asets/png/market.png"
//import Preview from '../../Publications/PreviewPublication./Preview';
//import "./Title.scss";
//import usePublic from '../../../hooks/usePublic';



export default function Promo (props) {
const  { publication , setShowModal } = props;
const [completPublic] = useMutation (PUBLIC_COMPLET);
const desk = publication.description


console.log(publication)

console.log (publication._id)



const formik = useFormik ({
  initialValues:initialValue(),


  validationSchema:Yup.object({
   
    mercado:Yup.string().required()
    

  }),


  onSubmit: async (formv) => {try
    { const formData= formv;
      console.log(formv);

       await completPublic({
        variables:{
          input:{
            idPublication:publication._id,
            mercado:formData.mercado,
            
          },
          },}
      );
      toast.success (" Publicacion vinculada 😁 ");

      setTimeout(() =>  setShowModal (false),3000);


      
}    catch (error) {
      toast.error(error.message);
      console.log (error)
      console.log (formv)
    }
  },

 });





  return (
    
        <Form  onSubmit = {formik.handleSubmit} className= "mosset">
        <h2> copia enlace  del articulo de mercado libre  y pegalo en el campo  </h2>
        <h2><Icon name="handshake outline" centered/></h2>
        <Divider/>
          
   <h2> Enlace  </h2>
         <Form.Input type= "Text" placeholder = "https://articulo.mercadolibre.com.mx/MLM-3462466906-xbox-clasico-10-gb-2-controles-lector-al-100-y-juegos-_JM?searchVariation=182218092292#polycard_client=search-nordic&searchVariation=182218092292&position=6&search_layout=stack&type=item&tracking_id=9228b732-"
         name= "mercado"  
         value = {formik.values.mercado}
        onChange = {formik.handleChange}
        error={formik.errors.mercado && true}

      />

      <Button type= "submit" className=' btn-submit'>  * Publicar * </Button> 

        </Form>
    
  )
}
function initialValue() {
  return  {
    "idPublication": "",
    "mercado": "",  
  };
};
